export const getVerifyEmail = ({ verifyEmail }) => verifyEmail.email;
export const getVerifyMessage = ({ verifyEmail }) => verifyEmail.message;
export const getLoadingVerifyEmail = ({ verifyEmail }) => verifyEmail.loading;
export const getErrorVerifyEmail = ({ verifyEmail }) => verifyEmail.error;
